export const AssignedToMe = 'AssignedToMe';
export const WhereStatus = 'WhereStatus';
export const CreatedWithin = 'CreatedWithin';
export const Overdue = 'Overdue';
